export enum VariableColumnType {
  Title = "title",
  Value = "value",
  Unit = "unit"
}